import React from 'react'
import {Box, Flex, useMultiStyleConfig} from '@chakra-ui/react'
import MenuVerticalCard from '../MenuVerticalCard'
import MenuSimpleCard from '../MenuSimpleCard'
import MenuGroupedCategories from '../MenuGroupedCategories'
import {getTemplateLinks, IconLinkButton, templatePropTypes} from './shared'
import {remCalc} from '../../../../theme/_utils'

export const getTemplateOneData = (primarycategory) => ({
    categoryGroup: primarycategory?.category_group ?? [],
    links: getTemplateLinks(primarycategory),
    simpleCards: primarycategory?.cards ?? [],
    verticalCards: Array.isArray(primarycategory?.images) ? primarycategory.images : [],
})

const TemplateOne = ({primarycategory, categoryData, locale}) => {
    const styles = useMultiStyleConfig('MenuTemplate', {variant: 'template-one'})
    const {categoryGroup, links, simpleCards, verticalCards} = getTemplateOneData(primarycategory)
    const hasTwoSimpleCards = simpleCards.length === 2

    return (
        <Box {...styles.templateContainer} data-primarycategory-id={primarycategory?.uid}>
            <Flex {...styles.layout}>
                <Flex {...styles.gridInnerContainer}>
                    {categoryData && categoryGroup.length > 0 && (
                        <Box {...styles.groupOuterContainer}>
                            <Flex {...styles.groupInnerContainer}>
                                <MenuGroupedCategories
                                    groupedCategories={categoryGroup}
                                    locale={locale}
                                    categoryData={categoryData}
                                    styles={styles}
                                />
                            </Flex>
                        </Box>
                    )}

                    {links.length > 0 && (
                        <Flex {...styles.linkContainer}>
                            {links.map((link, idx) => (
                                <IconLinkButton
                                    key={`menu-icon-link-button-${idx}`}
                                    link={link}
                                    categoryData={categoryData}
                                    locale={locale}
                                    styles={styles}
                                />
                            ))}
                        </Flex>
                    )}
                </Flex>

                <Flex {...styles.verticalCardsContainer}>
                    {verticalCards.map((card, idx) => (
                        <Box
                            key={card?._metadata?.uid ?? `menu-vertical-card-${idx}`}
                            {...styles.verticalCardWrapper}
                        >
                            <MenuVerticalCard
                                card={card}
                                categoriesData={categoryData}
                                locale={locale}
                            />
                        </Box>
                    ))}
                </Flex>

                {simpleCards.length > 0 && (
                    <Flex
                        {...styles.simpleCardsContainer}
                        gridAutoRows={hasTwoSimpleCards ? remCalc(221) : remCalc(140)}
                        display="grid"
                        tabIndex={0}
                    >
                        {simpleCards.map((card, idx) => (
                            <Box
                                key={`temp1-menu-simple-card-${idx}`}
                                display="flex"
                                minH="0"
                                minW="0"
                            >
                                <MenuSimpleCard
                                    card={card}
                                    categoriesData={categoryData}
                                    locale={locale}
                                    isLarge
                                />
                            </Box>
                        ))}
                    </Flex>
                )}
            </Flex>
        </Box>
    )
}

TemplateOne.propTypes = templatePropTypes

export default TemplateOne
